module.exports = __webpack_public_path__ + "media/images/icon-search-69fba67470ccd9a9c1072819e1c5acde.png";